import { Box , CircularProgress } from '@mui/material'
import { Suspense } from 'react'
import { useTranslation } from 'react-i18next'

import QueryErrorBoundary from '../components/QueryErrorBoundary'
import { useWorkingAddress } from '../store/store.hooks'
import BiReports from './Common/BiReportsComponent'
import Dashboards from './Common/Dashboards'
import SSRSReports from './Common/SSRSReportsComponent'
interface ProductLayoutProps {
  isConnected: boolean
  productName: string
  biReportNames: string[]
}

const ProductLayout = ({ isConnected, productName, biReportNames }: ProductLayoutProps) => {
  const { t } = useTranslation()
  const serverIP = useWorkingAddress()

  const toolLinks = [
    { title: t('tools.downtimeDocumentation'), href: `http://${serverIP}:49989` },
    //{ title: t('tools.editGaugeLimits'), href: `http://${serverIP}:49986/#/obeditor` }, hidden for now as we do not want all users to have access
    { title: t('tools.reportsPortal'), href: `http://${serverIP}:49990/Reports` },
  ]

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box id="test" sx={{ display: 'flex', flexDirection: 'row' }}></Box>
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Dashboards isConnected={isConnected} productName={productName} />
        
        <Box sx={{ display: 'flex', width: '100%', height: '100%' }}>
          <Box sx={{ flex: 1 }}>
            <SSRSReports isConnected={isConnected} productName={productName} />
          </Box>
          <Box sx={{ flexShrink: 0, minWidth: '70%' }}>
            <QueryErrorBoundary>
              <Suspense
                fallback={
                  <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                    <CircularProgress />
                  </Box>
                }
              >
                <BiReports nameList={biReportNames} />
              </Suspense>
            </QueryErrorBoundary>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ProductLayout
